import { withInstall } from '@bigin/utils'
import Teleport from './src/teleport.vue'

export const BTeleport = withInstall(Teleport)

export default BTeleport

export * from './src/teleport'
